import { render, staticRenderFns } from "./blueWay.vue?vue&type=template&id=8c8699fe&scoped=true&"
import script from "./blueWay.vue?vue&type=script&lang=js&"
export * from "./blueWay.vue?vue&type=script&lang=js&"
import style0 from "./blueWay.vue?vue&type=style&index=0&id=8c8699fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8699fe",
  null
  
)

export default component.exports